"use client";
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { motion } from "framer-motion";

import "swiper/css";
import "swiper/css/navigation";

import { makeStyles } from "@material-ui/core/styles";

// Dummy images (replace with actual imports)
import broadcastImg1 from "../../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../../images/v4/salesReps/Designfor/broadcast5.png";

// arrrow
import carouselArrow from "../../../images/v4/TgPages/next.svg";

// ---------- STYLES ----------
const useStyles = makeStyles(() => ({
  designCrmCarousel: {
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": { marginBottom: "24px" },
      "& p": { marginBottom: "16px" },

      "@media(max-width:768px)": {
        maxWidth: "100%",
        "& h2": { marginBottom: "16px" },
      },
    },

    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },

    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
  },

  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",

    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },

    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": { fontSize: "24px" },
    },

    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": { fontSize: "24px" },
    },
  },

  broadcastBox: {
    borderRadius: "20px",
    padding: "24px",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  cardHeader: {
    marginBottom: "12px",
  },

  cardPointer: {
    marginBottom: "8px",
  },

  broadcastImg: {
    maxWidth: "100%",
    height: "auto",
    marginTop: "16px",
  },

  navButton: {
    cursor: "pointer",
  },

  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex!important",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",
    gap: "40px",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "0 auto 0",
      display: "table",
    },
    "@media(max-width: 768px)": {
      width: "auto",
      maxWidth: "auto",
      padding: "16px 16px 0",
      gap: "24px",
    },
  },
}));

// ---------- DATA ----------
const broadcastList = [
  {
    link: "https://peppercloud.com/teams/crm-for-sales-managers",
    pointer: "CRM for sales managers",
    card: {
      pointer: [
        "Track sales performance, coach teams better, and scale revenue with real-time insights and reports.",
      ],
      img: broadcastImg1,
      alt: "Create whatsapp broadcast list",
      backgroundColor: "#f48446",
      backgroundImage: "linear-gradient(to bottom, #f48446, #783ca8)",
    },
  },
  {
    link: "https://peppercloud.com/teams/crm-for-sales-development-reps",
    pointer: "CRM for sales development reps",
    card: {
      pointer: [
        "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
      ],
      img: broadcastImg2,
      alt: "Create whatsapp broadcast message​",
      backgroundColor: "#014957",
      backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
    },
  },
  {
    link: "https://peppercloud.com/teams/crm-for-marketing-team/",
    pointer: "CRM for marketing teams",
    card: {
      pointer: [
        "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
      ],
      img: broadcastImg3,
      alt: "Create whatsapp broadcast message​",
      backgroundColor: "#31114b",
      backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8)",
    },
  },
  {
    link: "https://peppercloud.com/teams/crm-for-customer-support-teams",
    pointer: "CRM for customer support teams",
    card: {
      pointer: [
        "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
      ],
      img: broadcastImg4,
      alt: "CRM for Whatsapp broadcast",
      backgroundColor: "#2788e7",
      backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
    },
  },
  {
    link: "https://peppercloud.com/teams/crm-for-business-owners",
    pointer: "CRM for business owners",
    card: {
      pointer: [
        "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
      ],
      img: broadcastImg5,
      alt: "CRM for Whatsapp broadcast",
      backgroundColor: "#09939a",
      backgroundImage: "linear-gradient(to bottom, #09939a, #783ca8)",
    },
  },
];

// ---------- COMPONENT ----------
const DesignCrmCarousel = ({ backgroundImage, bgColor }) => {
  const classes = useStyles();
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section
      className={classes.designCrmCarousel}
      style={{
        backgroundImage: backgroundImage ? backgroundImage : "none",
        backgroundColor: bgColor ? bgColor : "#fff",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="container design-carousel-container">
        <div className="designHeader">
          <motion.h2
            className="font-wix-semibold font-56 color-black1"
            initial={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.6 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Designed for every team
          </motion.h2>
          <motion.p
            className="font-wix-regular font-18 color-black1"
            initial={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Designed to support sales, marketing, support, and business teams,
            Pepper Cloud CRM helps every team work smarter, faster, and more
            efficiently from one unified platform.
          </motion.p>
        </div>

        {/* Custom Navigation Buttons */}
        <div className="carousel-nav">
          <button className={`${classes.navButton} prev-btn`} ref={prevRef}>
            <img src={carouselArrow} />
          </button>
          <button className={`${classes.navButton} next-btn`} ref={nextRef}>
            <img src={carouselArrow} />
          </button>
        </div>
      </div>

      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            freeMode: true,
            spaceBetween: 30,
            grabCursor: false,
            centeredSlides: false,
            autoplay: false,
            modules: [Navigation],
          },
          500: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            freeMode: true,
            allowTouchMove: true,
            spaceBetween: 30,
            grabCursor: false,
            centeredSlides: false,
            autoplay: false,
            modules: [Navigation],
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            centeredSlides: true,
          },
          1024: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            centeredSlides: true,
          },
          1200: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            centeredSlides: true,
          },
        }}
        className={classes.broadcastContainerInner}
        loop={false}
        modules={[Navigation]}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        spaceBetween={30}
        speed={5000}
      >
        {broadcastList.map((point, index) => (
          <SwiperSlide
            className={classes.broadcastBox}
            key={`slide-${index}`}
            style={{
              backgroundColor: point.card.backgroundColor,
              backgroundImage: point.card.backgroundImage,
            }}
          >
            <a className={classes.broadcastLink} href={point.link}>
              <div className={classes.broadcastheader}>
                <div className={classes.cardHeader}>
                  <p className="font-24 font-wix-medium font-white">
                    {point.pointer}
                  </p>
                </div>
                {point.card.pointer.map((content, i) => (
                  <div className={classes.cardPointer} key={`content-${i}`}>
                    <p className="font-wix-regular font-16 font-white">
                      {content}
                    </p>
                  </div>
                ))}
              </div>
              <img
                alt={point.card.alt}
                className={classes.broadcastImg}
                src={point.card.img}
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default DesignCrmCarousel;
